import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useTranslation } from 'next-i18next'

import AuthChooseMethod from '../../features/auth/AuthChooseMethod'
import withAuthGuard from '../../features/auth/withAuthGuard'
import AuthLayout from '../../features/auth/AuthLayout'

export function AuthPage() {
  const { t } = useTranslation('auth')

  return (
    <AuthLayout title={t('chooseLoginMethod')}>
      <AuthChooseMethod />
    </AuthLayout>
  )
}

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common', 'auth'])),
  },
})

export default withAuthGuard(AuthPage, true)
